(() => {
  // Keep the app's single form, and apply the theme's courier-only rule.
  const syncDeliveryMode = () => {
    const marker = document.querySelector('[data-th-parcel-allowed]');
    const courierOnly = marker?.dataset.thParcelAllowed === 'false';
    document.querySelectorAll('.do-overlay .do-provider-methods').forEach((methods) => {
      const buttons = methods.querySelectorAll('button.do-pill');
      if (buttons.length !== 2) return;
      const pickup = buttons[0];
      const address = buttons[1];
      if (pickup.hidden !== courierOnly) pickup.hidden = courierOnly;
      if (courierOnly && address.getAttribute('aria-pressed') !== 'true') address.click();
    });
  };
  let pending = false;
  const scheduleSync = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      syncDeliveryMode();
    });
  };
  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-th-parcel-allowed', 'aria-pressed'],
  });
  syncDeliveryMode();
})();
